import React from 'react';
import { useStyletron } from 'baseui';
import { KIND as TAG_KIND, Tag } from 'baseui/tag';
import { LabelLarge } from 'baseui/typography';
type PendingAnnotationHeaderProps = {
  heading: string;
  description?: string;
  count?: number;
  countText?: string;
  showTag?: boolean;
};
const tagOverrides = {
  Root: {
    style: {
      margin: 0
    }
  }
};
export const PendingAnnotationHeader = ({
  heading,
  count = 0,
  countText = 'remaining',
  showTag = true
}: PendingAnnotationHeaderProps) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.sizing.scale200
  })}>
      <LabelLarge margin={0}>{heading}</LabelLarge>
      {showTag && count > 0 && <Tag overrides={tagOverrides} closeable={false} kind={TAG_KIND.warning}>
          {count} {countText}
        </Tag>}
    </div>;
};